export default {
    type: "heading",
    data: {
      paddingLeft: 10,
      paddingTop: 10,
      paddingBottom: 10,
      paddingRight: 10,
      html: "<h2 style=\"text-align: center;\">I'm a new heading block</h2>",
    },
  };
  